import React from 'react';
import './ContactSections.css';
import { useSelector } from 'react-redux';

const ContactSectionBL = () => {
  
  const contactBillund = useSelector((state) => state.ContactBillund);

  return (
    <div className="contact-sections">
      <div className="contact-section">
        <h3 className="section-title" style={{marginBottom:"30px"}}>{contactBillund?.phoneTitle}</h3>
        <div className="contact-item">
          <h4>{contactBillund?.phoneContactsHeading}</h4>
          <div style={{ marginTop: "5px" }}>
            {contactBillund?.phoneContacts?.map((contact, index) => (
              <p key={index} style={{ color: "#333333" }}>
                {contact.Title} {contact.Phone}
              </p>
            ))}
          </div>
        </div>
        <div className="contact-item">
          <h4>{contactBillund?.accountingCustomsHeading}</h4>
          {contactBillund?.accountingCustomsPhone?.map((item, index) => (
            <p key={index} style={{ color: "#333333" }}>
              {item.Title} {item.Number}
            </p>
          ))}
        </div>
      </div>
      <div className="contact-section">
        <h3 className="section-title" style={{marginBottom:"30px"}}>{contactBillund?.emailTitle}</h3>
        <div className="contact-item">
          <h4>{contactBillund?.emailHeading}</h4>

          {contactBillund?.customerServiceEmails?.map((email, index) => (
            <p key={index}>
              <a href={`mailto:${email}`} className="email-link">
                {email}
              </a>
            </p>
          ))}
        </div>
        <div className="contact-item">
          <h4>{contactBillund?.accountingCustomsHeading}</h4>

          {contactBillund?.accountingCustomsEmails?.map((email, index) => (
            <p key={index}>
              <a href={`mailto:${email}`} className="email-link">
                {email}
              </a>
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactSectionBL;
